import { postJson } from "./client";
import type { SimulationResult } from "./types";

export interface WireOp {
	assetId: string;
	deltaValueRaw: string;
}

export interface TransactionsBundleSimulateResponse {
	wallet: string;
	asOf: string;
	input: { ops: WireOp[] };
	simulation: SimulationResult;
}

export interface TransactionsBundleReceipt {
	bundleId: string;
	txHash: string;
	blockNumber: string;
	blockTimestamp: string;
	status: "success" | "reverted";
	/**
	 * Per-bundle count of `SettlementStepExecuted` events published —
	 * one per touched invest/divest step. Swaps don't emit. Useful for
	 * debugging "Execute landed but Portfolio didn't refresh" (a 0 here
	 * means accounting never got a chance to write the row).
	 */
	publishedEvents: number;
}

export type TransactionsBundleExecutionResult =
	| { ok: true; bundles: TransactionsBundleReceipt[] }
	| { ok: false; reason: string; bundles: TransactionsBundleReceipt[] };

export interface TransactionsBundleExecuteResponse {
	wallet: string;
	asOf: string;
	input: { ops: WireOp[] };
	simulation: SimulationResult;
	execution: TransactionsBundleExecutionResult;
}

export function postTransactionsBundleSimulate(
	ops: WireOp[],
): Promise<TransactionsBundleSimulateResponse> {
	return postJson<TransactionsBundleSimulateResponse>(
		"/transactions-bundle/simulate",
		{ ops },
	);
}

export function postTransactionsBundleExecute(
	ops: WireOp[],
): Promise<TransactionsBundleExecuteResponse> {
	return postJson<TransactionsBundleExecuteResponse>(
		"/transactions-bundle/execute",
		{ ops },
	);
}
